import React, { useEffect } from "react";
import "./InnerLandingPage.css";
import BuildExperience from "./BuildExperience";
import { useContent } from "../ContentContext";
import { motion } from "framer-motion";

// Import local images as fallbacks
import freightForwarding from "../public/images/freightForwarding.jpg";
import Aviation from "../public/images/logisticsImage/cover.jpg";
import OverseasEmployment from "../public/images/OverseasEmployment.jpg";
import traveling from "../public/images/logisticsImage/traveling.jpg";
import FoodProcessing from "../public/images/fish.jpg";
import Education from "../public/images/education_image.jpg";
import LearnMore from "./LearnMore";

// Video fallbacks (imported similarly to how images were in the original)
import videoSrc from "../public/images/logisticsImage/video.mp4";
import Forwardingvideo from "../public/images/freightForwarding/Forwardingvideo.mp4";
import OverseasEmploymentvideo from "../public/images/OverseasEmployment/OverseasEmployment.mp4";
import traveling_video from "../public/images/logisticsImage/traveling_video.mp4";
import fishvideo from "../public/images/foodimage/fishvideo.mp4";
import educationvideo from "../public/images/educationimages/educationvideo.mp4";

// Section Images fallbacks
import Forwardingimage1 from "../public/images/freightForwarding/Forwardingimage1.jpg";
import Forwardingimage2 from "../public/images/freightForwarding/Forwardingimage2.jpg";
import Forwardingimage3 from "../public/images/freightForwarding/Forwardingimage3.jpg";
import Forwardingimage7 from "../public/images/freightForwarding/Forwardingimage7.jpg";
import Forwardingimage8 from "../public/images/freightForwarding/Forwardingimage8.jpg";
import Forwardingimage9 from "../public/images/freightForwarding/Forwardingimage9.jpg";
import imagesec2 from "../public/images/logisticsImage/imagesec2.png";
import imagesec21 from "../public/images/logisticsImage/imagesec21.png";
import imagesec3 from "../public/images/logisticsImage/imagesec3.png";
import Forwardingimage10 from "../public/images/freightForwarding/Forwardingimage10.jpg";
import Forwardingimage11 from "../public/images/freightForwarding/Forwardingimage11.jpg";
import Forwardingimage6 from "../public/images/freightForwarding/Forwardingimage6.jpg";
import S4 from "../public/images/mnsaviators/M&S4.jpg";
import S2 from "../public/images/mnsaviators/M&S2.png";
import S3 from "../public/images/mnsaviators/M&S3.png";
import S7 from "../public/images/mnsaviators/M&S7.jpg";
import S6 from "../public/images/mnsaviators/M&S6.jpg";
import S5 from "../public/images/mnsaviators/M&S5.jpg";
import oneWindow1 from "../public/images/OverseasEmployment/OneWindow1 (1).jpg";
import oneWindow2 from "../public/images/OverseasEmployment/OneWindow1 (2).jpg";
import oneWindow3 from "../public/images/OverseasEmployment/OneWindow1 (3).jpg";
import oneWindow5 from "../public/images/OverseasEmployment/OneWindow1 (5).jpg";
import oneWindow6 from "../public/images/OverseasEmployment/OneWindow1 (6).jpg";
import oneWindow8 from "../public/images/OverseasEmployment/OneWindow1 (8).jpg";
import um1 from "../public/images/Insurance/um1.jpg";
import um2 from "../public/images/Insurance/um2.jpg";
import um3 from "../public/images/Insurance/um3.jpg";
import t1 from "../public/images/Insurance/t1.jpg";
import t2 from "../public/images/Insurance/t2.jpg";
import t3 from "../public/images/Insurance/t3.jpg";
import cow1 from "../public/images/foodimage/cow (1).jpg";
import cow2 from "../public/images/foodimage/cow (2).jpg";
import cow3 from "../public/images/foodimage/cow (3).jpg";
import side from "../public/images/foodimage/side.jpg";
import side1 from "../public/images/foodimage/why-us-1.jpg";
import side2 from "../public/images/foodimage/why-us-3.jpg";
import image1 from "../public/images/foodimage/image1.jpg";
import image2 from "../public/images/foodimage/image2.jpg";
import image3 from "../public/images/foodimage/image3.jpg";
import Image5 from "../public/images/foodimage/Image5.jpg";
import Image4 from "../public/images/foodimage/Image4 (1).jpg";
import Image6 from "../public/images/foodimage/Image6.jpg";
import veg1 from "../public/images/foodimage/veg1 (1).jpg";
import veg2 from "../public/images/foodimage/veg1 (2).jpg";
import veg3 from "../public/images/foodimage/veg1 (3).jpg";
import insurance1 from "../public/images/Insurance/insurance (1).jpg";
import insurance2 from "../public/images/Insurance/insurance (2).jpg";
import insurance3 from "../public/images/Insurance/insurance (3).jpg";
import softskills from "../public/images/educationimages/softskills (1).jpg";
import softskills1 from "../public/images/educationimages/softskills (2).jpg";
import softskills2 from "../public/images/educationimages/softskills (3).jpg";
import kcompute1 from "../public/images/Picture2.jpg";
import kcompute2 from "../public/images/Picture2.png";
import kcompute3 from "../public/images/kcompute3.jpg";

const categoryImageMap = {
  'freightForwarding': freightForwarding,
  'Logistics': Aviation,
  'OverseasEmployment': OverseasEmployment,
  'Insurance': traveling,
  'FoodProcessing': FoodProcessing,
  'Education': Education
};

const videoMap = {
  "/images/logisticsImage/video.mp4": videoSrc,
  "/images/freightForwarding/Forwardingvideo.mp4": Forwardingvideo,
  "/images/logisticsImage/traveling_video.mp4": traveling_video,
  "/images/OverseasEmployment/OverseasEmployment.mp4": OverseasEmploymentvideo,
  "/images/foodimage/fishvideo.mp4": fishvideo,
  "/images/educationimages/educationvideo.mp4": educationvideo
};

const sectionImageMap = {
  "/images/freightForwarding/Forwardingimage1.jpg": Forwardingimage1,
  "/images/freightForwarding/Forwardingimage2.jpg": Forwardingimage2,
  "/images/freightForwarding/Forwardingimage3.jpg": Forwardingimage3,
  "/images/freightForwarding/Forwardingimage7.jpg": Forwardingimage7,
  "/images/freightForwarding/Forwardingimage8.jpg": Forwardingimage8,
  "/images/freightForwarding/Forwardingimage9.jpg": Forwardingimage9,
  "/images/logisticsImage/imagesec2.png": imagesec2,
  "/images/logisticsImage/imagesec21.png": imagesec21,
  "/images/logisticsImage/imagesec3.png": imagesec3,
  "/images/freightForwarding/Forwardingimage10.jpg": Forwardingimage10,
  "/images/freightForwarding/Forwardingimage11.jpg": Forwardingimage11,
  "/images/freightForwarding/Forwardingimage6.jpg": Forwardingimage6,
  "/images/mnsaviators/M&S4.jpg": S4,
  "/images/mnsaviators/M&S2.png": S2,
  "/images/mnsaviators/M&S3.png": S3,
  "/images/mnsaviators/M&S7.jpg": S7,
  "/images/mnsaviators/M&S6.jpg": S6,
  "/images/mnsaviators/M&S5.jpg": S5,
  "/images/OverseasEmployment/OneWindow1 (1).jpg": oneWindow1,
  "/images/OverseasEmployment/OneWindow1 (2).jpg": oneWindow2,
  "/images/OverseasEmployment/OneWindow1 (3).jpg": oneWindow3,
  "/images/OverseasEmployment/OneWindow1 (5).jpg": oneWindow5,
  "/images/OverseasEmployment/OneWindow1 (6).jpg": oneWindow6,
  "/images/OverseasEmployment/OneWindow1 (8).jpg": oneWindow8,
  "/images/Insurance/um1.jpg": um1,
  "/images/Insurance/um2.jpg": um2,
  "/images/Insurance/um3.jpg": um3,
  "/images/Insurance/t1.jpg": t1,
  "/images/Insurance/t2.jpg": t2,
  "/images/Insurance/t3.jpg": t3,
  "/images/foodimage/cow (1).jpg": cow1,
  "/images/foodimage/cow (2).jpg": cow2,
  "/images/foodimage/cow (3).jpg": cow3,
  "/images/foodimage/side.jpg": side,
  "/images/foodimage/why-us-1.jpg": side1,
  "/images/foodimage/why-us-3.jpg": side2,
  "/images/foodimage/image1.jpg": image1,
  "/images/foodimage/image2.jpg": image2,
  "/images/foodimage/image3.jpg": image3,
  "/images/foodimage/Image5.jpg": Image5,
  "/images/foodimage/Image4 (1).jpg": Image4,
  "/images/foodimage/Image6.jpg": Image6,
  "/images/foodimage/veg1 (1).jpg": veg1,
  "/images/foodimage/veg1 (2).jpg": veg2,
  "/images/foodimage/veg1 (3).jpg": veg3,
  "/images/Insurance/insurance (1).jpg": insurance1,
  "/images/Insurance/insurance (2).jpg": insurance2,
  "/images/Insurance/insurance (3).jpg": insurance3,
  "/images/educationimages/softskills (1).jpg": softskills1,
  "/images/educationimages/softskills (2).jpg": softskills1,
  "/images/educationimages/softskills (3).jpg": softskills2,
  "/images/Picture2.jpg": kcompute1,
  "/images/Picture2.png": kcompute2,
  "/images/kcompute3.jpg": kcompute3,
};

const InnerLandingPage = ({ Name }) => {
  const { content, loading } = useContent();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Name]);

  if (loading || !content) {
    return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>Loading...</div>;
  }

  const pageData = content.innerPages[Name];
  if (!pageData) return <div>Page Not Found</div>;

  // Function to process images with fallbacks
  const processImages = (obj) => {
    const newObj = { ...obj };
    Object.keys(newObj).forEach(key => {
      if (typeof newObj[key] === 'string' && (newObj[key].startsWith('/images') || newObj[key].startsWith('http'))) {
        const path = newObj[key];
        newObj[key] = path.startsWith('http') ? path : (sectionImageMap[path] || path);
      }
    });
    return newObj;
  };

  const processedSections = processImages(pageData);
  const bannerImage = categoryImageMap[Name] || processedSections.imagesec1;
  const videoSrcPath = videoMap[pageData.heroVideo] || pageData.heroVideo;

  return (
    <div className="InnerLandingPage">
      <motion.div
        className="hero"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, duration: 0.5 }}
      >
        <video
          key={videoSrcPath}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={bannerImage}
          className="hero-video"
        >
          <source src={videoSrcPath} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="overlay">
          <h1 className="title">
            <span>{pageData.pageTitle}</span>
          </h1>
        </div>
      </motion.div>

      <br /><br /><br /><br />

      <BuildExperience
        SectionsImg={processedSections}
        Images={bannerImage}
      />


    </div>
  );
};

export default InnerLandingPage;
